import Splide from "@splidejs/splide";
import PlayYouTubeVideo from "./PlayYouTubeVideo";

export default class MainSlider {
    constructor() {
        this.mainSlider = "";
        this.sliderVideoContainers = "";
        this.slider = document.querySelector(".jsSliderMain");
        if (this.slider) {
            this.sliderSlides =
                this.slider.querySelectorAll(".jsSliderMainSlide");
            this.events();
        }
    }

    events() {
        if (this.sliderSlides.length > 1) {
            this.initializeMainSlider();
            this.mainSlider.on(
                "mounted",
                this.grabAllVideoContainers.bind(this)
            );
            this.mainSlider.mount();
        } else {
            this.grabAllVideoContainers();
        }
    }

    initializeMainSlider() {
        this.mainSlider = new Splide(this.slider, {
            type: "loop",
            arrows: false,
            pagination: true,
            perPage: 1,
            perMove: 1,
            trimSpace: true,
            autoplay: true,
            interval: 5000,
            breakpoints: {
                1023: {
                    arrows: false,
                },
            },
        });
    }

    grabAllVideoContainers() {
        this.sliderVideoContainers = document.querySelectorAll(
            ".jsSliderMainSlideWrap"
        );

        if (this.sliderVideoContainers.length) {
            this.loadYoutubeIFrameApiScript();
        }
    }

    loadYoutubeIFrameApiScript() {
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";

        document.body.insertAdjacentElement("beforeend", tag);

        tag.onload = this.checkAndPlayVideoOnSlides.bind(this);
    }

    checkAndPlayVideoOnSlides() {
        this.sliderVideoContainers.forEach((slide, idx) => {
            // eslint-disable-next-line no-unused-vars
            const videoPlayer = new PlayYouTubeVideo(slide, idx);
        });
    }
}
